import type { RouteRecordRaw } from 'vue-router'

import { routeItemsModuleRoot } from '@/routers/routes/mainRoutes/routeServices/routeItems'
import { routePricesRoot } from '@/routers/routes/mainRoutes/routeServices/routePrices'
import { routeUOMRoot } from '@/routers/routes/mainRoutes/routeServices/uomRoutes.ts'

import { routeActivityTypesRoot } from './activityTypesRoutes'
import { routeItemsHome } from './routeItems/itemsRoutes'

const routeServicesHome: RouteRecordRaw = {
  name: 'services-home',
  path: '',
  redirect: routeItemsHome,
}

const routeServicesRoot: RouteRecordRaw = {
  children: [
    routeServicesHome,
    routePricesRoot,
    routeItemsModuleRoot,
    routeActivityTypesRoot,
    routeUOMRoot,
  ],

  path: 'services',
}

export { routeServicesRoot }
